import {$getSelection, $isElementNode, $isRangeSelection, ElementNode, LexicalNode} from "lexical"
import {$createFontColorNode, $isFontColorNode, FontColorType} from "../font-color-plugin";
import {FontColorNode} from "../node/font-color-node";
import {lexicalGetAncestor} from "../../../../actions/get-ancestor";
import {$isBadgeNode} from "../../badge/badge-plugin";
import {clearNodeFormatting} from "../../../../actions/clear-formatting";

const debug = false
// const debug = "toggleFontColor"

export default function toggleFontColor(fontColorType:FontColorType | null) {
    const selection = $getSelection()

    if (!$isRangeSelection(selection)) {
        return
    }
    let nodes = selection.extract()

    debug && console.log(debug, 'nodes', nodes)

    if (!fontColorType) {
        // Remove FontColorNodes
        _.map(nodes, (node) => {
            const parent = node.getParent()

            if (parent && $isFontColorNode(parent)) {
                clearNodeFormatting(parent)
            }
        })
    } else {
        debug && console.log(debug, 'Add or merge FontColorNodes', nodes.length)

        // Remove BadgeNodes and FontColorNodes
        _.map(nodes, (node) => {
            const parent = node.getParent()

            if (parent && ($isBadgeNode(parent) || $isFontColorNode(parent))) {
                clearNodeFormatting(parent)
            }
        })

        // select again (badge nodes cleared and new nodes may appear)
        nodes = selection.extract()

        // Add or merge FontColorNodes
        if (nodes.length === 1) {
            const firstNode = nodes[0];

            const nodeToReplace = $isFontColorNode(firstNode)
                ? firstNode
                : lexicalGetAncestor(firstNode, $isFontColorNode)

            debug && console.log(debug, 'fontColorNode', nodeToReplace)

            if (nodeToReplace !== null) {
                nodeToReplace.replace($createFontColorNode(fontColorType), true)
                return
            }
        }

        let prevParent: ElementNode | FontColorNode | null = null;
        let fontColorNode: FontColorNode | null = null

        _.map(nodes, (node) => {
            const parent = node.getParent()

            if (
                parent === fontColorNode ||
                parent === null ||
                ($isElementNode(node) && !node.isInline())
            ) {
                return;
            }

            if ($isFontColorNode(parent)) {
                fontColorNode = parent as FontColorNode
                return
            }

            if (!parent.is(prevParent)) {
                prevParent = parent;
                fontColorNode = $createFontColorNode(fontColorType);

                if ($isFontColorNode(parent)) {
                    if (node.getPreviousSibling() === null) {
                        parent.insertBefore(fontColorNode)
                    } else {
                        parent.insertAfter(fontColorNode)
                    }
                } else {
                    node.insertBefore(fontColorNode)
                }
            }

            if ($isFontColorNode(node)) {
                if (node.is(fontColorNode)) {
                    return
                }

                if (fontColorNode !== null) {
                    const children = node.getChildren()

                    for (let i = 0; i < children.length; i++) {
                        fontColorNode.append(children[i])
                    }
                }

                node.remove()
                return
            }

            if (fontColorNode !== null) {
                fontColorNode.append(node)
            }
        })
    }
}

function $getFontColorAncestor(node: LexicalNode): null | LexicalNode {
    return lexicalGetAncestor(node, $isFontColorNode);
}